<!-- Ported from the Polaris kit: src/components/ui/input/Input.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Polaris patch (woot, phase P): `reset-base` opts out of the app's global `input[type]` rule (_base.scss: field-base,
     margin, h-10), which drew a second box inside InputGroup and resized typed fields. A re-port drops it: re-apply. -->
<script setup>
import { useVModel } from '@vueuse/core';
import { cn } from '../../lib/utils';

const props = defineProps({
  defaultValue: { type: [String, Number], required: false },
  modelValue: { type: [String, Number], required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const emits = defineEmits(['update:modelValue']);

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    data-slot="input"
    :class="
      cn(
        'reset-base file:text-polaris-foreground placeholder:text-polaris-muted-foreground selection:bg-polaris-primary selection:text-polaris-primary-foreground dark:bg-polaris-input/30 border-polaris-input h-9 w-full min-w-0 rounded-polaris-md border border-solid bg-transparent px-3 py-1 text-base shadow transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:type-polaris-body file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:type-polaris-body',
        'focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive',
        props.class
      )
    "
  />
</template>
